import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import Seo from "@/components/Seo";
import { PageHero, Section, Btn } from "@/components/kit";
import { Reveal } from "@/lib/anim";
import { track } from "@/lib/analytics";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const FILES = [
  { slug: "first-production-run-checklist", h: "First Production Run Checklist", p: "Everything to confirm before you place a first order into Australia: costing, quantities and suppliers." },
  { slug: "factory-questions-list", h: "Factory Questions List", p: "The questions that tell a factory apart from a trading company, and a real MOQ from a fabric minimum." },
  { slug: "landed-cost-worksheet", h: "Landed Cost Worksheet", p: "How to build the number that actually decides your margin, with a worked example." },
  { slug: "tech-pack-checklist", h: "Tech Pack Checklist", p: "What a factory needs before it can quote or build, and the gaps that cost you sample rounds." },
];

function DownloadCard({ file }) {
  const [email, setEmail] = useState("");
  const [news, setNews] = useState(false);
  const [busy, setBusy] = useState(false);

  const get = async (e) => {
    e.preventDefault();
    if (!email.trim()) { toast.error("Add your email to receive the PDF."); return; }
    setBusy(true);
    try {
      await axios.post(`${API}/downloads/request`, { email: email.trim(), slug: file.slug, newsletter: news });
      track("download", { slug: file.slug });
      window.location.href = `${API}/downloads/${file.slug}`;
      toast.success("Your download is starting.");
      setEmail("");
    } catch {
      toast.error("Could not start the download. Please try again.");
    }
    setBusy(false);
  };

  return (
    <div className="card p-8 flex flex-col" data-testid={`download-${file.slug}`}>
      <h2 className="t-h3">{file.h}</h2>
      <p className="t-sm text-[var(--muted)] mt-3 flex-1">{file.p}</p>
      <form onSubmit={get} className="mt-6">
        <input type="email" className="field" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid={`download-email-${file.slug}`} />
        <label className="flex items-center gap-3 mt-3">
          <input type="checkbox" checked={news} onChange={(e) => setNews(e.target.checked)} className="w-4 h-4 accent-[var(--clay)]" />
          <span className="t-caption text-[var(--muted)]">Send me occasional notes on cost, margin and sourcing</span>
        </label>
        <Btn type="submit" variant="clay" className="w-full justify-center mt-4" data-testid={`download-get-${file.slug}`}>{busy ? "Preparing\u2026" : "Get the PDF"}</Btn>
      </form>
    </div>
  );
}

export default function Downloads() {
  return (
    <>
      <Seo title="Free downloads" canonical="/tools/downloads" description="Free branded checklists and question lists for fashion founders: first production run, factory questions, landed cost worksheet and tech pack checklist." />
      <PageHero
        eyebrow="Free downloads"
        crumbs={[{ label: "Home", to: "/" }, { label: "Tools", to: "/tools" }, { label: "Downloads" }]}
        title="Checklists and question lists, as PDFs."
        lead="Practical documents you can take straight to a supplier. Enter an email and the PDF downloads immediately."
      />
      <Section bg="bone">
        <div className="grid md:grid-cols-2 gap-6">
          {FILES.map((f, i) => <Reveal i={i % 2} key={f.slug}><DownloadCard file={f} /></Reveal>)}
        </div>
      </Section>
    </>
  );
}
